
import { Component, Mixins } from "vue-property-decorator";
import Booking from "@/interfaces/Contracts/Booking";
import { getBookingSites } from "@/repositories/Contracts/BookingsRepository";
import BookingSite from "@/interfaces/Contracts/BookingSite";
import CardListDetailDetailCardMixin from "@/mixins/CardListDetailDetailCardMixin";
import BaseDetailCard from "@/components/Base/CardListDetail/BaseDetailCard.vue";
import CardListDetailNavigationOptions from "@/interfaces/Base/CardListDetail/CardListDetailNavigationOption";
import DetailBookingHeader from "@/components/Contracts/Bookings/DetailBookingHeader.vue";
import DetailBookingSites from "@/components/Contracts/Bookings/DetailBookingSites.vue";

@Component({
  components: {
    BaseDetailCard,
    DetailBookingHeader,
    DetailBookingSites,
  },
})
export default class ViewBookingsDetailCard extends Mixins(
  CardListDetailDetailCardMixin
) {
  navigationOptions = {
    name: "Details",
    navigationOptions: [
      {
        name: "Sites",
      },
    ],
  } as CardListDetailNavigationOptions;
  selectedSite: BookingSite | null = null;

  async selectedLayerChanged(): Promise<void> {
    if (this.selectedLayer === "Sites") {
      await this.setBookingSites();
    }
  }

  async setBookingSites(): Promise<void> {
    this.selectedSite = null;

    if (this.selectedItem.sites) {
      if (this.selectedItem.sites.length > 0) {
        this.selectedSite = this.selectedItem.sites[0];
      }
      return;
    }

    this.loading = true;
    await getBookingSites(
      this.selectedItem.bookingId,
      this.selectedItem.itemId,
      this.selectedItem.effective
    )
      .then((response: BookingSite[]) => {
        this.selectedItem.sites = response;

        if (this.selectedItem.sites.length > 0) {
          this.selectedSite = this.selectedItem.sites[0];
        }
      })
      .finally(() => (this.loading = false));
  }

  get title() {
    return `${this.selectedBooking.bookingId}`;
  }

  get selectedBooking(): Booking {
    return this.selectedItem as Booking;
  }
}
